<template>
  <div>
    <template v-for="(item, index) in menu" >
      <!-- 有子菜单 -->
      <el-submenu v-if="item.children" :index="index + ''" :key="index">
        <template slot="title">
          <!-- <span style="font-size: 16px;" :class="item.icon"></span> -->
          <i class="el-icon-menu"></i>
          <span style="padding-left: 10px;">{{item.name}}</span>
        </template>
        <!-- 递归 -->
        <menu-sun :menu="item.children" />
      </el-submenu>
      <!-- 没有子菜单 -->
      <el-menu-item :index="item.href" :key="index + ''" v-else >
        <!-- <i class="el-icon-menu"></i> -->
        <span style="font-size: 16px;" :class="item.icon"></span>
        <span slot="title" style="padding-left: 10px;">{{item.name}}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
import MenuSun from '@/components/menuList/MenuList.vue'
export default {
  name: 'MenuSun', // 递归组件
  components: {
    MenuSun
  },
  props: ['menu'],
  methods: {
    handleState(row) {
      // this.resetSetItem('watchStorage', row.href)
    }
  }
}
</script>

<style>
.el-menu--collapse .el-submenu__title span {
  display: none;
}
.el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}
</style>

<style lang="less" scoped>
.el-submenu .el-menu-item {
  // background-color: #00518C !important;
  background-color: #333744 !important;
}
.el-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.2) !important;
}
// .el-menu-item:hover {
//   color: red !important;
// }
.el-menu-item.is-active:hover {
  // color: #474747 !important;
  background-color: rgba(42, 51, 70, 1);
}
.el-menu-item.is-active {
  // color: #474747 !important;
  background-color: #EFF2F5 !important;
}
</style>
